export class User {
  avatar: string;
  avatar_thumbnail: string;
  id: number;
  group: number;
  first_name: string;
  last_name: string;
  user: {'email': '', 'is_active': ''};
  name: string;
  email: string;
}
